import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy `/manage/org` entry point. There has never been an org *section*
 * under /manage — org administration IS the Manage console — but the path is
 * a natural guess and was linked from authored demo content, where it 404'd.
 * Redirect to /manage (which forwards on to the default Members section),
 * exactly as the older `/admin/org` shim in `_app/admin.org.tsx` does.
 *
 * Deliberately NOT redirecting to `/admin/org`: that route is itself only a
 * redirect to /manage, so pointing here would add a hop and break the moment
 * the legacy admin shim is retired. */
export const Route = createFileRoute("/manage/org")({
  beforeLoad: () => {
    throw redirect({ to: "/manage" });
  },
});
